// 详情
<template>
  <div class="form-single-fragment" style="position: relative">
    <el-form
      ref="formData"
      :model="formData"
      class="full-width-input"
      :rules="rules"
      style="width: 100%"
      label-width="100px"
      size="small"
      label-position="right"
      @submit.native.prevent
    >
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="标签模板名称" prop="modelName">
            <el-input
              class="input-item"
              v-model="formData.modelName"
              :clearable="true"
              placeholder="标签模板名称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="模板类型" prop="modelType">
            <el-select
              v-model="formData.modelType"
              placeholder="模板类型"
              clearable
              filterable
            >
              <el-option
                v-for="item in modelTypeArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="二维码尺寸" prop="qrSize">
            <el-input
              class="input-item"
              v-model="formData.qrSize"
              :clearable="true"
              placeholder="二维码尺寸"
            />
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="标签展示字段" prop="qrSize">
            <el-table :data="columnArr" border style="width: 100%">
              <el-table-column prop="label" label="字段标示">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.label"
                    placeholder=""
                    size="small"
                    clearable
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="key" label="字段key">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.key"
                    placeholder=""
                    size="small"
                    clearable
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    type="danger"
                    @click="delItem(scope.$index, scope.row)"
                  >
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="" prop="qrSize">
            <el-button type="primary" size="small" @click="addItem()">
              添加
            </el-button>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-row class="no-scroll flex-box" type="flex" justify="end">
            <el-button size="small" @click="diaClose" :plain="true">
              取 消
            </el-button>
            <el-button size="small" type="primary" @click="onSave">
              确 认
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "LabelModel",
  props: {
    row: Object,
  },
  data() {
    return {
      formData: {
        id: null,
        modelColumn: "",
        modelName: "",
        modelSize: "/",
        modelType: null,
        qrCode: "/",
        qrSize: "",
      },
      columnArr: [],
      rules: {},
      modelTypeArr: [
        { label: "原材料", value: 1 },
        { label: "模具", value: 2 },
        { label: "成品", value: 3 },
      ],
    };
  },
  methods: {
    addItem() {
      this.columnArr.push({
        label: "",
        key: "",
      });
    },
    delItem(i, row) {
      this.columnArr.splice(i, 1);
    },

    onSave() {
      this.formData.modelColumn = JSON.stringify(this.columnArr);
      this.$refs["formData"].validate((valid) => {
        if (valid) {
          if (this.formData.id) {
            this.$emit("onUpdate", { dto: { ...this.formData } });
          } else {
            let { id, ...par } = this.formData;
            this.$emit("onAdd", { dto: { ...par } });
          }
        } else {
          this.$message("请填写完整");
          return false;
        }
      });
    },
    diaClose() {
      this.$emit("diaClose");
    },
  },
  computed: {
    // isEdit () {
    //   return this.postId != null;
    // }
  },
  mounted() {},
  created() {
    if (this.row.id) {
      Object.keys(this.formData).forEach((key) => {
        this.formData[key] = this.row[key];
      });
      this.formData.id = this.row.id;
      console.log("this.formData", this.formData);
      this.columnArr = JSON.parse(this.formData.modelColumn);
    }
  },
  watch: {},
};
</script>
